export default __webpack_public_path__ + "static/media/hosting_action_bg.d38bf54d.png";